import React from 'react';
import PropTypes from 'prop-types';

import {
  DivStyledAgentInitials,
  PictureStyled,
  SpanStyledAgentPlaceholderInitials,
} from './styles';

export const AgentInitials = ({
  firstName,
  lastName,
  photoProportion,
  prependPictureChildren,
}) => <SpanStyledAgentPlaceholderInitials photoProportion={photoProportion}>{prependPictureChildren}<span>{firstName?.substring(0, 1)} {lastName?.substring(0, 1)}</span></SpanStyledAgentPlaceholderInitials>;

const AgentPhoto = ({
  agentDisplayVariant = 'financialAdvisorMatch',
  agentImageUrl,
  agentName,
  photoProportion = 'portrait',
  prependPictureChildren,
  styles,
  themeType = 'lightTheme',
}) => {
  if (agentImageUrl) {
    return <PictureStyled
      agentDisplayVariant={agentDisplayVariant}
      altText={agentName.fullName}
      baseImageProps={{
        itemProp: 'image',
        className: 'aura-picture u-photo',
      }}
      className='aura-agent-photo'
      fullWidth
      lazyLoad={false}
      photoProportion={photoProportion}
      prependPictureChildren={prependPictureChildren}
      src={agentImageUrl}
      styles={styles || {}}
    />;
  }

  return <DivStyledAgentInitials
    className='aura-agent-photo'
    photoProportion={photoProportion}
  >
    <AgentInitials
      agentDisplayVariant={agentDisplayVariant}
      firstName={agentName.firstName}
      lastName={agentName.lastName}
      photoProportion={photoProportion}
      prependPictureChildren={prependPictureChildren}
    />
  </DivStyledAgentInitials>;
};

AgentPhoto.propTypes = {
  /** optional parent usage variant value that trickles down into children Components  */
  agentDisplayVariant: PropTypes.string,
  /** Optional agent image url - if not supplied, will render agent initials */
  agentImageUrl: PropTypes.string,
  /** Required agent name object */
  agentName: PropTypes.shape({
    firstName: PropTypes.string,
    fullName: PropTypes.string,
    lastName: PropTypes.string,
    middleName: PropTypes.string,
  }).isRequired,
  /** optional photo proportion */
  photoProportion: PropTypes.oneOf(['portrait', 'square']),
  /** optional prepend children */
  prependChildren: PropTypes.node,
  /** optional image styles */
  styles: PropTypes.object,
  /** Optional themeType */
  themeType: PropTypes.oneOf(['lightTheme', 'darkTheme']),
};

export default AgentPhoto;
